import request from "@/utils/request";

export function getBannerListApi(funcId) {
  return request({
    url: "bannerList?funcId=" + funcId,
    method: "GET",
  });
}

export function getDataListApi(page, size, funcId, title) {
  return request({
    url: "dataList",
    method: "POST",
    data:{
      pageNum: page,
      pageSize: size,
      funcId: funcId,
      title: title,
    }
  });
}

export function getFunctionListApi(funcId) {
  return request({
    url: "functionList?parentId=" + funcId,
    method: "GET",
  });
}

export function getHomeFriendLinksListApi() {
  return request({
    url: "homeFriendLinksList",
    method: "GET",
  });
}

export function getHomeHonorListApi(page, size) {
  return request({
    url: "homeHonorList?pageNum=" + page + "&pageSize=" + size,
    method: "GET",
  });
}

export function getHomeImagesListApi(page, size) {
  return request({
    url: "homeImagesList?pageNum=" + page + "&pageSize=" + size,
    method: "GET",
  });
}

export function getHomeNewsListApi(page, size) {
  return request({
    url: "homeNewsList?pageNum=" + page + "&pageSize=" + size,
    method: "GET",
  });
}

export function getHomeNoticeListApi(page, size) {
  return request({
    url: "homeNoticeList?pageNum=" + page + "&pageSize=" + size,
    method: "GET",
  });
}

export function getHomeOftenLinksListApi() {
  return request({
    url: "homeOftenLinksList",
    method: "GET",
  });
}

export function getHomeSubjectListApi(page, size) {
  return request({
    url: "homeSubjectList?pageNum=" + page + "&pageSize=" + size,
    method: "GET",
  });
}

// 新增访问人数
export function addVisitLogApi(page, size) {
  return request({
    url: "addVisitLog",
    method: "GET",
  });
}

export function getVisitLogCountApi(page, size) {
  return request({
    url: "getVisitLogCount",
    method: "GET",
  });
}

export function getVirtualImageApi(page, size) {
  return request({
    url: "virtualImage",
    method: "GET",
  });
}
export function osConfigListApi() {
  return request({
    url: "osConfigList",
    method: "GET",
  });
}

export function getNewsInfoApi(funcId, newsId) {
  return request({
    url: "newsInfo?funcId=" + funcId + "&newsId=" + newsId,
    method: "GET",
  });
}

export function getTicket() {
  return request({
    url: "getTicket",
    method: "GET",
  });
}

